import cx from "classnames";

import Button from "client/common/components/buttons/Button";

import { ActionContentBlock as ActionContentBlockType } from "../../types";
import MarkdownText from "../helper/MarkdownText";

import styles from "../../styles/ActionContentBlock.module.less";

type ActionContentBlockProps = {
  block: ActionContentBlockType;
  className: string;
};

const ActionContentBlock = ({ block, className }: ActionContentBlockProps) => {
  return (
    <div className={cx(styles.container, className)}>
      <div className={styles.main}>
        {block.header && (
          <h4 className={styles.header}>
            <MarkdownText value={block.header} />
          </h4>
        )}
        {block.content && block.content.length && (
          <div className={styles.content}>
            {block.content.map((content) => (
              <MarkdownText key={content} value={content} />
            ))}
          </div>
        )}
      </div>
      {block.action && (
        <div className={styles.actions}>
          <Button className={styles.action} href={block.action.url}>
            {block.action.text}
          </Button>
        </div>
      )}
    </div>
  );
};

export default ActionContentBlock;
